/**
 *  @class
 *  @function MediaWithTabs
 */
if (!customElements.get('multi-page-with-navigation')) {
  class MultiPageWithNavigation extends HTMLElement {
    
    /**
     * Variable used to distinguish between a link click and a scroll event
     * @date 10/16/2023 - 3:48:43 PM
     *
     * @type {boolean}
     */
    linkClicked;

    constructor() {
      super();
      this.linkClicked = false;
    }
    connectedCallback() {
      const self = this;
      this.buttons = Array.from(this.querySelectorAll('button.multi-page-with-navigation--button'));
      this.pages = Array.from(this.querySelectorAll('.multi-page-with-navigation--page'));
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', () => {
          self.linkClicked = true;
          this.buttonClick(button, i);
        });
      });

      // Add an event listener for the scroll event
      this.onScroll();

      const selectButtons = this.querySelector('.multi-page-with-navigation--select');

      if (selectButtons) {
        selectButtons.addEventListener('change', (e) => {
          self.linkClicked = true;

          // Get the button same as the value of the select
          const button = this.querySelector(`button.multi-page-with-navigation--button[data-value="${e.target.value}"]`);

          // Get index of the button
          const index = this.buttons.indexOf(button);

          // Click the button
          this.buttonClick(button, index);
        });
      }
    }
    buttonClick(button, i) {
      const self = this;

      [].forEach.call(this.buttons, function(el) {
        el.classList.remove('active');
      });
      button.classList.add('active');

      let header_offset = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      let page_top = this.pages[i].getBoundingClientRect().top + window.scrollY - parseInt(header_offset, 10) - 20;
      
      window.scrollTo({
        top: page_top,
        left: 0,
        behavior: "smooth"
      });

      // Reset linkClicked flag after a delay (e.g., 1000ms)
      setTimeout(function () {
        self.linkClicked = false;
      }, 1000);
    }

    selectChange(select,i){
      const self = this;
      let header_offset = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      let page_top = this.pages[i].getBoundingClientRect().top + window.scrollY - parseInt(header_offset, 10) - 90;
      window.scrollTo({
        top: page_top,
        left: 0,
        behavior: "smooth"
      });

      // Reset linkClicked flag after a delay (e.g., 1000ms)
      setTimeout(function () {
        self.linkClicked = false;
      }, 1000);
    }

    onScroll() {
      const self = this;
      const $pages = this.pages;
      const $buttons = this.buttons;
      const offset = 400;

      const selectButtons = this.querySelector('.multi-page-with-navigation--select');

      // Add an event listener for the scroll event
      window.addEventListener('scroll', () => {
        // Check if a link was clicked, if so, ignore the scroll event
        if (self.linkClicked) {
          return;
        }

        // Calculate the current scroll position
        const currentScroll = window.scrollY + offset;

        // Loop through the pages and determine which one is currently in view
        $pages.forEach((page, i) => {
          const pageTop = page.getBoundingClientRect().top + window.scrollY;
          const pageBottom = pageTop + page.clientHeight;

          // Check if the current scroll position is within the bounds of the page
          if (currentScroll >= pageTop && currentScroll < pageBottom) {
            // Remove the 'active' class from all buttons
            $buttons.forEach((button) => {
              button.classList.remove('active');
            });

            // Add the 'active' class to the corresponding button
            $buttons[i].classList.add('active');

            // Change the select value
            if (selectButtons) {
              selectButtons.value = $buttons[i].dataset.value;
            }
          }
        });
      });
    }
  }
  customElements.define('multi-page-with-navigation', MultiPageWithNavigation);
}